<template>
  <section class="page_padd page_padd_m">
    <div class="login_box pay_box">
      <div class="corner-top"></div>
      <div class="title_has_svg">
        <PASSWORD />
        <h2 class="title center">שחזור סיסמה</h2>
      </div>
      <div class="login_inner">
        <div class="pass-st3" v-if="stage==1">
          <form id="formPass" name="passreset" @submit.prevent="sendNewPassword" novalidate>
            <div class="password_text">הזנת סיסמה</div>
            <div class="clearfix">
              <div class="form_tx">סיסמא חדשה</div>
              <div class="form_input">
                <input
                  type="password"
                  name="password_1"
                  id="pass1"
                  v-model="password_1"
                  v-validate="'required'"
                />
                <span class="eye" @click="showPassword('pass1')">
                  <EYE />
                </span>
              </div>
            </div>
            <div class="clearfix">
              <div class="form_tx">סיסמא בשנית</div>
              <div class="form_input">
                <input
                  class
                  :class="{error : password_2 != password_1 && password_2.length > 0}"
                  type="password"
                  id="pass2"
                  v-validate="'required'"
                  v-model="password_2"
                  name="password_2"
                />
                <span class="eye" @click="showPassword('pass2')">
                  <EYE />
                </span>
                <span class="input-ok" v-if="password_1 == password_2 && password_2.length > 0">
                  <OK />
                </span>
                <div
                  class="error_tx"
                  v-if="password_2 != password_1 && password_2.length > 0 "
                >צריך לכתוב את הסיסמה פעמיים</div>
              </div>
            </div>
            <input type="hidden" name="reset_key" :value="this.$route.query.key" />
            <input type="hidden" name="reset_login" :value="this.$route.query.id" />
            <div class="submit_bt ease">
              <input type="submit" value="עדכון סיסמה" />
            </div>
          </form>
        </div>

        <div class="pass-st4" v-if="stage==2">
          <div class="ok-thank">
            <OK />
          </div>
          <div class="password_text">
            <b>תודה, סיסמתך עודכנה בהצלחה!</b>
          </div>
          <div class="bt_border ease">
            <a href="#" @click.prevent="returnHome">ועכשיו, בחזרה לעמוד הבית</a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CLOSE from "../assets/img/close.svg";
import PASSWORD from "../assets/img/password.svg";
import OK from "../assets/img/ok.svg";
import EYE from "../assets/img/eye.svg";
import axios from "axios";
export default {
  data() {
    return {
      stage: "1",
      password_1: "",
      password_2: "",
      key: this.$route.query.key,
      id: this.$route.query.id,
      error: ""
    };
  },
  mounted() {
    this.stage = "1";
  },
  methods: {
    returnHome: function(red) {
      this.$router.push("/");
    },
    showPassword: function(name) {

      var x = document.getElementById(name);
      if (x.type === "password") {
        x.type = "text";
      } else {
        x.type = "password";
      }
    },
    sendNewPassword: function() {
      this.$validator.validate().then(result => {
        if (result) {
          let form = document.querySelector("#formPass");
          let data = new FormData(form);

          this.$ajax
            .post(
              `${this.$wpData.home_url}?passReset&password_1=${this.password_1}&password_2=${this.password_2}&reset_key=${this.key}&reset_login=${this.id}`
            )
            .then(res => {
              if (res.data.return == "Fine") {
                this.stage = 2;
              } else {
                this.error = res.data.returnTxt;
              }
            });
        }
      });
    }
  },
  components: {
    CLOSE,
    PASSWORD,
    OK,
    EYE
  }
};
</script>

<style scoped>
</style>